import { TableCell, TableRow, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CircleIcon from '@mui/icons-material/Circle';
import { Box } from '@mui/system';
import './ConsultRequestRow.css'
import ExploreRules from '../../../models/EquivalencyRuleActivity';

interface ConsultRequestRowProps {
  row: ExploreRules
}
const ConsultRequestRow:React.FC<ConsultRequestRowProps> = ({ row }) => {
  return (
    <TableRow>
      <TableCell align="left" scope="row">
        {row.input?.map((row, i) => (
          <Box key={row.id ?? i} sx={{ display: 'flex' }}>
            <CircleIcon fontSize="small" className='circleIconConsultRequestRow' data-testid="circle-icon"/>
            <Typography key={row.id}>{row.name}</Typography>
          </Box>
        ))}
      </TableCell>
      <TableCell align="left" scope="row">
        {row.output?.map((row, i) => (
          <Box key={row.id ?? i} sx={{ display: 'flex' }}>
            <CheckIcon fontSize="small" className='checkIconConsultRequestRow' data-testid="check-icon"/>
            <Typography key={row.id}>{row.name}</Typography>
          </Box>
        ))}
      </TableCell>
    </TableRow>
  );
};

export default ConsultRequestRow;
